import type { LowQualityReason } from "@/lib/audio-recorder/audio-quality-monitor";
import type { RecorderState } from "@/lib/audio-recorder/recorder";
import type { User } from "@/types";

export const userEventModel = (user: User) => ({
  name: user.name,
  email: user.email,
  locale: user.locale,
  avatar: user.avatar,
  default_team_id: user.default_team_id,
  email_verified_at: user.email_verified_at,
  last_logged_in_at: user.last_logged_in_at,
  created_at: user.created_at,
  updated_at: user.updated_at,
});

export const recordingEventModel = (state: RecorderState) => ({
  recording: state,
});

export const audioWarningEventModel = (reason?: LowQualityReason | null) => ({
  ...(reason ? { reason } : {}),
});
